import { useMutation, useQueryClient } from '@tanstack/react-query';
import ExerciceService from '../Services/exercices/ExerciceService';
import { toast } from 'sonner';
import { GET_EXERCICES_QUERY_KEY } from '../queries/useGetExercices';

export const useExerciceMutations = () => {
  const queryClient = useQueryClient();

  const createExerciceMutation = useMutation({
    mutationFn: (exercicesData) => ExerciceService.createNewExercices(exercicesData),
    onSuccess: () => {
      queryClient.invalidateQueries([GET_EXERCICES_QUERY_KEY]);
      toast.success("Exercices créés avec succès");
    },
    onError: (error) => {
      toast.error(`Échec de la création : ${error.message}`);
    },
  });

  const updateExerciceMutation = useMutation({
    mutationFn: ({ id, data }) => ExerciceService.updateExerciceDetails(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries([GET_EXERCICES_QUERY_KEY]);
      toast.success("Exercice mis à jour avec succès");
    },
    onError: (error) => {
      toast.error(`Échec de la mise à jour : ${error.message}`);
    },
  });

  const deleteExerciceMutation = useMutation({
    mutationFn: (id) => ExerciceService.deleteExercice(id),
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([GET_EXERCICES_QUERY_KEY]);
        toast.success("Exercice supprimé avec succès");
      } else {
        toast.error("Une erreur s'est produite lors de la suppression de l'exercice.");
      }
    },
    onError: (error) => {
      toast.error(`Échec de la suppression : ${error.message}`);
    },
  });
  const deleteExerciceMediaMutation = useMutation({
    mutationFn: (id) => ExerciceService.deleteExerciceMedia(id),
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([GET_EXERCICES_QUERY_KEY]);
        toast.success("Média de l'exercice supprimé avec succès");
      } else {
        toast.error("Une erreur s'est produite lors de la suppression du média de l'exercice.");
      }
    },
    onError: (error) => {
      toast.error(`Échec de la suppression : ${error.message}`);
    },
  });

  return {
    createExerciceMutation,
    updateExerciceMutation,
    deleteExerciceMutation,
    deleteExerciceMediaMutation
    
  };
};